import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-form-checkbox',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <app-form-label style="display: inline-block">
            <g-row>
                <g-col>
                    <div class="{{showAsSingleField ? 'form-element form-element--checkbox-wrapper' : ''}}">
                        <div class="custom-checkbox"
                             [class.custom-checkbox--checked]="input.checked"
                             [class.custom-checkbox--disabled]="fbControl.disabled">
                            <input #input type="checkbox" [formControl]="fbControl">
                        </div>
                    </div>
                </g-col>
                <g-col *ngIf="showContent && !showAsSingleField" [grow]="true" [paddingLeft]="0">
                    <ng-content></ng-content>
                </g-col>
            </g-row>
        </app-form-label>`,
})

export class FormCheckboxComponent implements OnInit, OnDestroy {
    @Input() fbControl: FormControl = new FormControl();
    @Input() showContent = true;
    @Input() showAsSingleField = false;

    private sub: Subscription;

    constructor(
        private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.sub = this.fbControl.statusChanges.subscribe(status => {
            this.cd.detectChanges();
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
